module.exports = __webpack_public_path__ + "static/horizon_banners-ffe4f77a07ef4af01445040be5655a0b.png";